module.exports = "<div class=header-bar> <div class=title> <ol class=\"breadcrumb mb0 no-padding\"> <li class=active> <a translate>Skills</a> </li> </ol> </div> </div> <skills-list-component employee-skills=$ctrl.employeeSkills></skills-list-component>";


//////////////////
// WEBPACK FOOTER
// ./src/app/modules/skills/skills.dashboard.html
// module id = 493
// module chunks = 0